import {ChecklistRepository, Pagination} from '../repository/ChecklistRepository';
import {Checklist, ChecklistFilters} from '../models/checklist.model';

export class ListChecklistsUseCase {
  constructor (private checklistRepository: ChecklistRepository) {}

  async execute (
    page = 1,
    limit = 20,
    filters?: ChecklistFilters
  ): Promise<{ items: Checklist[]; pagination?: Pagination }> {
    return this.checklistRepository.list(page, limit, filters);
  }
}
